import type { IDocumentData } from '@models/document/IDocumentData';

/**
 * Данные формы для черновика — без выбранных файлов.
 *
 * `files.files` — массив `File`, который `JSON.stringify` превращает в `{}`, а
 * `files.attachProperties` — строки таблицы вложений. Восстановление такого черновика
 * вернуло бы строки без бинарников: файлы выглядели бы выбранными, а на сохранении
 * в FormData ушло бы `undefined`. Черновик файлов не хранит — блок вложений об этом
 * предупреждает подписью «Файлы сохранятся вместе с документом».
 */
export const toDraftPayload = (values: IDocumentData): Omit<IDocumentData, 'files'> => {
    const { files: _files, ...rest } = values;
    return rest;
};

/** Снять `files` с данных черновика, сохранённого до введения {@link toDraftPayload}. */
export const stripDraftFiles = (data: IDocumentData): IDocumentData => {
    if (!data?.files) return data;
    const { files: _files, ...rest } = data;
    return rest as IDocumentData;
};
